export const getErrorMessage = (error) => {
  const { response, message: errMessage } = error || {};
  const { status, data } = response || {};
  const { message } = data || {};
  const msg = message || errMessage;
  return { status, message: msg };
};

export const NotificationType = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
};
